import type { ReactNode } from 'react'
import styles from './Sentence.module.css'

export interface SentenceProps {
  /**
   * Controls and {@link SentenceText}s, in reading order.
   */
  children?: ReactNode
}

/**
 * Lays out controls and text as a sentence that wraps, like "[Pro has all
 * of] the following skills".
 */
export function Sentence({ children }: SentenceProps) {
  return <div className={styles.root}>{children}</div>
}

export interface SentenceTextProps {
  children: string
}

/**
 * The words of a {@link Sentence} between its controls.
 */
export function SentenceText({ children }: SentenceTextProps) {
  return <span className={styles.text}>{children}</span>
}
